import { useModeratorStore, } from "../../../store/moderatorStore.ts";
import { OperationsListDefault, } from "./OperationsListDefault.tsx";
import { OperationsListModerator, } from "./OperationsListModerator.tsx";

export interface IOperationsListProps {
  /**
   * * default - this the default variant with a link to the "how to page"
   * * tiny - this is the variant for list usage
   */
  emptyBlockVariant?: "default" | "tiny";
}

/**
 * Operation is installment or purchase in terms of application logic.
 *
 * This block is responsible for displaying the list of all instalments,
 * skeletons, and placeholders.
 */
export function OperationsList({ emptyBlockVariant = "default", }: IOperationsListProps,) {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator
        ? (
          <OperationsListModerator emptyBlockVariant={emptyBlockVariant} />
          )
        : (
          <OperationsListDefault emptyBlockVariant={emptyBlockVariant} />)}
    </>
  );
}
